class ContactTabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const trigger = document.querySelectorAll(".contactTabLink");
    const panel = document.querySelectorAll(".contactTabPanel");
    const contactTxt = document.querySelector(".contact-txt");


    // 全てのtabChangeLinkのクラス、番号を取得
    trigger.forEach((item, index) => {
      
      // tabChangeLinkをクリックした時
      item.addEventListener('click', () => {
        const triggerIndex = index;
        const triggerItem = item;
        const getTrigger = document.querySelectorAll(".contactTabLink");
        getTrigger.forEach((item, index) => {
          item.classList.remove('is-active');
        });
        // 全てのtabChangePanelを取得
        panel.forEach((item, index) => {
          // もし取得した番号が完全に一致したら
          item.classList.remove('is-active');
          if( triggerIndex === index ){
            item.classList.add('is-active');
            triggerItem.classList.add('is-active');
          }
        });

        $("[name='tab']").val(item.getAttribute('value'));
      });
    });

    if($("[name='tab']").val() === '採用に関するご相談') {
      $("[value='入所に関するご相談'], .contactTabPanelAdmission").removeClass('is-active');
      $("[value='採用に関するご相談'], .contactTabPanelRecruit").addClass('is-active');
    }

    if($('.mw_wp_form_send_error').length || $('.mw_wp_form_complete').length) {
      $("[value='入所に関するご相談'], .contactTabPanelAdmission").removeClass('is-active');
      $("[value='採用に関するご相談'], .contactTabPanelRecruit").addClass('is-active');
      $('.contactTabPanel').removeClass('is-active');
      $('.mw_wp_form_send_error').parent().addClass('is-active');
      $('.mw_wp_form_complete').parent().addClass('is-active');
    }

    if($('.mw_wp_form_confirm').length >= 1) {
      $('.contact-txt').text('入力内容にお間違いがないかご確認ください。')
    } 
    
    if($('.mw_wp_form_complete').length >= 1 ) {
      $('.contact-txt').text('')
      $('.contactTabArea').addClass('is-hidden');
      
    }
  }
}